export default __webpack_public_path__ + "static/media/mysql.bdf16cd9.png";